import { Box, Typography } from '@mui/material'
import Step2Image from 'assets/images/artists/step2.webp'
import { AppStoreLogo } from 'components/icon'
import NextImage from 'next/image'

import Step from './Step'

const Step2Left = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '2rem',
        width: '80%',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: ' white ',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Download the app & complete your profile
      </Typography>
      <Typography variant="bodyLato1" sx={{ color: ' white ' }}>
        Lorem ipsum dolor sit amet consectetur. Cursus magna risus laoreet
        lobortis vel aliquet. Nulla pulvinar cursus eget pharetra tincidunt
        donec arcu commodo at. Auctor ultrices non interdum sem.
      </Typography>
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <AppStoreLogo store="apple" transparent />
        <AppStoreLogo store="google" transparent />
      </Box>
    </Box>
  )
}

const Step2Right = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '80%',
      }}
    >
      <NextImage src={Step2Image} alt="step-1" />
    </Box>
  )
}

const Step2 = () => {
  return (
    <Step stepNum={2} left={<Step2Left />} right={<Step2Right />} fullHeight />
  )
}
// const Step2 = () => {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         height: '100vh',
//         alignItems: 'center',
//         gap: '2rem',
//       }}
//     >
//       <Box
//         sx={{
//           maxWidth: '45%',
//           padding: '6.5rem',
//           display: 'flex',
//           gap: '2rem',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '2rem',
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{
//               color: ' white ',
//               display: 'flex',
//               alignItems: 'center',
//             }}
//           >
//             Download the app & complete your profile
//           </Typography>
//           <Typography variant="bodyLato1" sx={{ color: ' white ' }}>
//             Lorem ipsum dolor sit amet consectetur. Cursus magna risus laoreet
//             lobortis vel aliquet. Nulla pulvinar cursus eget pharetra tincidunt
//             donec arcu commodo at. Auctor ultrices non interdum sem.
//           </Typography>
//           <Box sx={{ display: 'flex', gap: '1rem' }}>
//             <AppStoreLogo store="apple" transparent />
//             <AppStoreLogo store="google" transparent />
//           </Box>
//         </Box>
//       </Box>
//       <Box
//         sx={{
//           border: '2px solid white',
//           minWidth: '3.75rem',
//           height: '3.75rem',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           margin: '0 2rem',
//         }}
//       >
//         <Typography
//           variant="bodyLato1"
//           sx={{ color: ' white', fontWeight: 800, fontSize: '1.25rem' }}
//         >
//           2
//         </Typography>
//       </Box>
//       <Box sx={{ maxWidth: '45%' }}>
//         <NextImage src={Step2Image} alt="step-1" />
//       </Box>
//     </Box>
//   )
// }

// const Step2 = () => {
//   return (
//     <Grid container sx={{ height: '100vh' }}>
//       <Grid
//         item
//         xs={5}
//         sx={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             gap: '2rem',
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{
//               color: ' white ',
//               display: 'flex',
//               alignItems: 'center',
//             }}
//           >
//             Download the app & complete your profile
//           </Typography>
//           <Typography variant="bodyLato1" sx={{ color: ' white ' }}>
//             Lorem ipsum dolor sit amet consectetur. Cursus magna risus laoreet
//             lobortis vel aliquet. Nulla pulvinar cursus eget pharetra tincidunt
//             donec arcu commodo at. Auctor ultrices non interdum sem.
//           </Typography>
//           <Box sx={{ display: 'flex', gap: '1rem' }}>
//             <AppStoreLogo store="apple" transparent />
//             <AppStoreLogo store="google" transparent />
//           </Box>
//         </Box>
//       </Grid>
//       <Grid
//         item
//         xs={2}
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           padding: '4rem',
//           alignItems: 'center',
//         }}
//       >
//         <Box
//           sx={{
//             border: '2px solid white',
//             minWidth: '3.75rem',
//             maxWidth: '3.75rem',
//             height: '3.75rem',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             // margin: '0 2rem',
//           }}
//         >
//           <Typography
//             variant="bodyLato1"
//             sx={{ color: ' white', fontWeight: 800, fontSize: '1.25rem' }}
//           >
//             2
//           </Typography>
//         </Box>
//       </Grid>
//       <Grid
//         item
//         xs={5}
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           padding: '4rem',
//           alignItems: 'center',
//         }}
//       >
//         <Box>
//           <NextImage src={Step2Image} alt="step-1" />
//         </Box>
//       </Grid>
//     </Grid>
//   )
// }

export default Step2
